import { atom } from "jotai";

export interface GDPR {
  isAccepted: boolean;
}

export const gdprAtom = atom<GDPR>({
  isAccepted: false,
});
